import Head from "next/head";
import Magazine from "../../../components/collection/magazine";
import { Breakpoint } from "../../../utils/media-query";

const CharmsMagazine = () => {
  const [isDesktop, isTablet, isMobile] = Breakpoint();

  return (
    <>
      <Head>
        <title>Charms Magazine | Aurum Lab</title>
        <meta
          name="description"
          content="Like putting together a story, here's the charms to celebrate every moment of your life. Find your 9K gold charms from Aurum Lab for every day life."
        />
      </Head>
      <main></main>
      <div className={isDesktop ? "container" : "container-mobile"}>
        <Magazine src="https://e.issuu.com/embed.html?backgroundColorFullscreen=%23ffffff&d=charm_collection&doAutoflipPages=true&hideIssuuLogo=true&hideShareButton=true&showOtherPublicationsAsSuggestions=true&u=aurumlab" />
      </div>
    </>
  );
};
export default CharmsMagazine;
